module.exports = __webpack_public_path__ + "img/OF18NR0.f297ba41.jpg";